
import L from 'leaflet';
import { createSelector } from 'reselect';

import {
  partyColumns, allVotesColumn, validVotesColumn, getPartyColor
} from '~/scripts/config';
import { sortByKey, isNumeric } from '~/core/scripts/utils';

function sumupColumns(data, columns) {
  return data.reduce((res, feat) => {
    columns.forEach(col => {
      const val = isNumeric(feat.properties[col]) ? feat.properties[col] : 0;

      res[col] = res[col] ? res[col] : 0;
      res[col] += val;
    });

    return res;
  }, {});
}

function sumupData(features) {
  const sumColumns = [...partyColumns, validVotesColumn, allVotesColumn];
    const summedValues = sumupColumns(features, sumColumns);

    return Object.keys(summedValues).reduce((res, col) => {
      if (![validVotesColumn, allVotesColumn].includes(col)) {
        const item = {
          name: col,
          value: summedValues[col],
          valueRel: (summedValues[col] / summedValues[validVotesColumn]) * 100,
          valueRelTrue: (summedValues[col] / summedValues[allVotesColumn]) * 100,
          color: getPartyColor(col)
        };

        res.push(item)
      }

      return res;
    }, []).sort(sortByKey('valueRel'));
}

export const mapBoundsSelector = state => state.data ? L.geoJSON(state.data).getBounds() : null;
export const maxBoundsSelector = createSelector(
  mapBoundsSelector,
  mapBounds => mapBounds ? mapBounds.pad(0.2) : null
);
const featuresSelector = state => state.data ? state.data.features : [];
const activeAnalysisSelector = state => state.selectedAnalysis;

export const filteredFeaturesSelector = createSelector(
  featuresSelector,
  activeAnalysisSelector,
  (features, analysis) => {
    if (!features) {
      return [];
    }

    let filteredFeatures = [];

    if (analysis.name === 'idfilter') {
      filteredFeatures = features.filter(feat => analysis.ids.includes(feat.properties.Wahlgebiet_ID));
    }

    if (analysis.name === 'true') {
      filteredFeatures = features.filter(feat => feat.properties.nonVotersRel > feat.properties.partyItems[0].valueRel);
    }

    return filteredFeatures;
  }
);

export const summedupDataSelector = createSelector(
  featuresSelector,
  sumupData
);

export const filteredSummedUpDataSelector = createSelector(
  filteredFeaturesSelector,
  sumupData
);
